/**
 * @description Gestion des images et effets associés
 */

(() => {
	const figureContainer = () => {
		document.querySelectorAll('.figure-full__legend').forEach((figure) => {
			figure.classList.remove('col-lg-9', 'offset-lg-3');
			figure.classList.add('container');
		});
	};

	/**
	 * @description Permet de déterminer ,si liste il y a,  quand un élément de la liste passe en dessous de l'image
	 */

	const figureCol = () => {
		const wrapperFigure =
			document.querySelectorAll('.figure-container') || null;
		if (wrapperFigure) {
			wrapperFigure.forEach((item) => {
				const figureH = item.querySelector('figure').offsetHeight;
				const figureOffsetTop = item.querySelector('figure').offsetTop;
				const limitFigure = figureH + figureOffsetTop;
				const figureList =
					item.querySelector('.figure-description ul') || null;
				if (figureList) {
					figureList.nextSibling.style.float = 'left';
					figureList.nextSibling.style.marginTop = '15px';
					const allItems = figureList.querySelectorAll('li');
					allItems.forEach((el) => {
						const elTop = el.offsetTop;
						if (elTop > limitFigure) {
							el.style.width = '100%';
						}
					});
				}
			});
		}
	};

	// GO 🚀
	const init = () => {
		figureContainer();
		window.addEventListener('DOMContentLoaded', () => {
			figureCol();
		});
	};

	init();
})();
